'use client';

import Card_AircraftUpcomingBookings from '@/components/elements/cards/card_aircraftbookings';
import Card_AircraftDocs from '@/components/elements/cards/card_aircraftdocs';
import Card_BookingCalendar from '@/components/elements/cards/card_bookingCalendar';
import Card_AircraftStats from '@/components/elements/cards/card_aircraftstats';

export default function Home() {
  return (
    <div>
      <div>
        <div>
          <h1 className='scroll-m-20 p-5 text-4xl font-extrabold tracking-tight lg:text-5xl'>
            G-BAKW
          </h1>
        </div>
        <div className='flex flex-col gap-3 xl:flex-row'>
          <div className='xl:w-[65%]'>
            <Card_BookingCalendar />
          </div>
          <div className='flex flex-1 flex-col space-y-3 xl:w-[35%]'>
            <div>
              <Card_AircraftStats />
            </div>
            <div className=''>
              <Card_AircraftDocs />
            </div>
            <div className='flex flex-grow flex-col'>
              <Card_AircraftUpcomingBookings />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
